import { v4 as uuidv4 } from 'uuid';

const transformAssociationFFnumber = {
  toAPIModel(data) {
    const date = new Date();
    const timestamp = date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds();

    return {
      'componentID': '',
      'endpoint': '/ffn-association',
      'messageType': 'REQUEST_MESSAGE',
      'timestamp': timestamp,
      'transactionID': uuidv4(),
      'data': {
        'frequentFlyerNumber': data.frequentFlyerNumber,
        'frequentFlyerProgram': data.frequentFlyerProgram,
        'lastName': data.lastName,
        'pnr': data.pnr,
      },
    };
  },
  fromApiModel(data) {
    return {
      [data?.firstname?.toUpperCase() + data?.lastname?.toUpperCase() + data?.birthday]: {
        ffn: data?.accountNumber,
        ffp: data?.loyaltyProgram,
      },
    };
  },
};

export default transformAssociationFFnumber;